<template>
  <div>
    <div>{{$t('message.script_logs_filtered_activity')}}</div>
    <b-container fluid>
      <b-row class="align-items-center">
        <b-col lg="6">
          <b-form-group :label="$t('message.script_logs_activity_search')" label-for="filter-input"
            label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0" >
            <b-input-group size="sm">
              <b-form-input id="filter-input" v-model="filter" type="search"
                :placeholder="$t('message.script_logs_filtered_activity_search_placeholder')">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button class="padmin-button submit-button" variant="secondary" @click="download"
            :disabled="runInProgress || downloadInProgress || !this.filteredActivityLog || this.filteredActivityLog.length == 0">
            <b-spinner v-if="downloadInProgress" small type="grow"/>
            {{$t('message.button_download') | title}}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-table striped hover :items="filteredActivityLog" :fields="fields" :filter="filter"
      :filter-included-fields="filterOn">
    </b-table>
    <b-alert v-model="showError" variant="danger" dismissible @dismissed="error=''; showError=false;">
      <div> {{error}} </div>
    </b-alert>
  </div>
</template>

<script>
import ConsoleOutput from "./ConsoleOutput";
import { get, post, forceFileDownload } from "../http";

export default {
  name: "FilteredActivityLog",

  data() {
    return {
      output: '',
      fields: [
        {key: 'start_date', sortable: true}, {key: 'duration', sortable: true, label: 'Duration (sec)'},
        {key: 'user_alias', sortable: true, label: 'User'}, {key: 'entity_alias', sortable: true, label: 'Entity'},
        {key: 'action', sortable: true}, {key: 'business_result', sortable: true},
        {key: 'failure_code', sortable: true}],
      filteredActivityLog: [],
      filter: null,
      filterOn: ['action', 'failure_code'],
      error: null,
      showError: false,
      runInProgress: false,
      downloadInProgress: false
    }
  },

  mounted() {
    this.loadFilteredActivityLog()
  },

  methods: {
    loadFilteredActivityLog() {
      this.filteredActivityLog = []
      this.error = null
      this.showError = false
      this.runInProgress = true
      this.downloadInProgress = false

      get('/filtered_activity_log').then(
        resp => {
          this.runInProgress = false
          if (resp.data.filtered_activity_log) {
            this.filteredActivityLog = resp.data.filtered_activity_log
            for (let index = 0; index < this.filteredActivityLog.length; index++) {
              this.filteredActivityLog[index].action = this.filteredActivityLog[index].type
              delete this.filteredActivityLog[index].type
            }
          } else {
            this.error = resp.data.error
            this.showError = true
          }
        },
        err => {
          this.runInProgress = false
          this.error = err
          this.showError = true
          console.log("err", err)
        }
      )
    },

    download() {
      this.downloadInProgress = true
      forceFileDownload(JSON.stringify(this.filteredActivityLog), 'anonymous_audit_log.json', {type: "application/json"})
      this.downloadInProgress = false
    }
  }
}
</script>
<style scoped>
.table td{
  height: 65px;
  overflow: auto;
  display: inline-block;
}
</style>
